export interface CaptureExceptionOptions {
  extra?: Record<string, unknown>
  tags?: Record<string, string | number | boolean | null | undefined>
  level?: 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug'
  fingerprint?: string[]
}

export interface ExceptionCapturingClient {
  captureException: (
    exception: unknown,
    hint?: CaptureExceptionOptions,
  ) => string
}

/**
 * Builds an app-level captureException helper bound to a specific Sentry
 * client (@sentry/react, @sentry/electron/main, ...). Unlike the previous
 * `{ extra }`-only wrappers, the options expose Sentry's tags, level, and
 * fingerprint so call sites don't have to bypass the helper to use them.
 */
export const createCaptureException =
  (sentryClient: ExceptionCapturingClient) =>
  (exception: unknown, options?: CaptureExceptionOptions): void => {
    sentryClient.captureException(exception, options)
  }
